import { render, staticRenderFns } from "./RegisterAccount.vue?vue&type=template&id=1c5150e8"
import script from "./RegisterAccount.vue?vue&type=script&lang=js"
export * from "./RegisterAccount.vue?vue&type=script&lang=js"
import style0 from "./RegisterAccount.vue?vue&type=style&index=0&id=1c5150e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports